module.exports = __webpack_public_path__ + "static/media/prime-video-logo.ce182b15.svg";